module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="preview-outer-container experience-container">\n    <div class="preview-inner-container"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/viewer/ExperiencePreview.tpl
// module id = 3038
// module chunks = 0